import React, { useEffect, useState } from "react";
import "./orderFilter.scss";
import {
  AppBar,
  Avatar,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import orderStore from "../../../stores/orderStore";

// Date Picker
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// Date Picker

// Icon
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OrderFilter = ({
  orderID,
  setOrderID,
  customerName,
  setCustomerName,
  staringDate,
  setStaringDate,
  endingDate,
  setEndingDate,
  staringPrice,
  setStaringPrice,
  endingPrice,
  setEndingPrice,
  deliveryStatus,
  setDeliveryStatus,
}) => {
  const max_width600 = useMediaQuery("(max-width:600px)");
  const [open, setOpen] = useState(false);
  const [endingDateError, setEndingDateError] = useState(false);
  const [endingPriceError, setEndingPriceError] = useState(false);
  const todayDate = new Date();
  const OrderStore = orderStore();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApply = () => {
    let flag = true;
    if (
      orderID === "" &&
      customerName === "" &&
      staringDate === null &&
      endingDate === null &&
      staringPrice === "" &&
      endingPrice === "" &&
      deliveryStatus === ""
    ) {
      OrderStore.setOrderFilterApply({ value: 0 });
    } else {
      if (staringDate !== null) {
        if (endingDate === null) {
          flag = false;
          setEndingDateError(true);
        } else {
          setEndingDateError(false);
        }
      }
      if (staringPrice !== "") {
        if (endingPrice === "") {
          flag = false;
          setEndingPriceError(true);
        } else {
          setEndingPriceError(false);
        }
      }
      
      if (flag) {
        OrderStore.setOrderFilterApply({
          value: ++OrderStore.orderFilterApply,
        });
      }
    }
    if (flag) {
      handleClose();
    }
  };

  const clearAll = () => {
    OrderStore.setOrderFilterApply({ value: 0 });
    setOrderID("");
    setCustomerName("");
    setStaringDate(null);
    setEndingDate(null);
    setStaringPrice("");
    setEndingPrice("");
    setDeliveryStatus("");
  };

  return (
    <div className="order-filter">
      <div className="filter-btn">
        <Chip
          avatar={
            <Avatar className="avatar">
              <FilterListRoundedIcon className="icon" />
            </Avatar>
          }
          label={<p>Filter</p>}
          variant="outlined"
          onClick={handleClickOpen}
        />
      </div>
      <Dialog
        fullScreen={max_width600 ? true : false}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="md"
      >
        {max_width600 ? (
          <AppBar sx={{ position: "relative" }}>
            <Toolbar style={{ background: "#000" }}>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseRoundedIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Search Filter
              </Typography>
              <Button autoFocus color="inherit" onClick={handleApply}>
                Apply
              </Button>
            </Toolbar>
          </AppBar>
        ) : (
          <DialogTitle>Search Filter</DialogTitle>
        )}

        <DialogContent>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  disabled={OrderStore.orderFilterApply === 0 ? true : false}
                  onClick={clearAll}
                >
                  Clear All
                </Button>
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Order ID"
                variant="outlined"
                fullWidth
                name="orderID"
                value={orderID}
                onChange={(e) => {
                  const { value } = e.target;
                  setOrderID(value);
                }}
                InputProps={{
                  endAdornment: orderID !== "" && (
                    <IconButton size="small" onClick={() => setOrderID("")}>
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Customer Name"
                variant="outlined"
                fullWidth
                name="customerName"
                value={customerName}
                onChange={(e) => {
                  const { value } = e.target;
                  setCustomerName(value);
                }}
                InputProps={{
                  endAdornment: customerName !== "" && (
                    <IconButton
                      size="small"
                      onClick={() => setCustomerName("")}
                    >
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "DesktopDatePicker",
                    "MobileDatePicker",
                  ]}
                >
                  <DatePicker
                    label="Starting Date"
                    maxDate={dayjs(todayDate)}
                    format="DD/MM/YYYY"
                    name="startingDate"
                    value={staringDate}
                    onChange={(value) => {
                      setStaringDate(value);
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {staringDate !== null && (
                <Button
                  sx={{ mt: 1, mb: -1 }}
                  onClick={() => {
                    setStaringDate(null);
                    setEndingDateError(false);
                  }}
                  size="small"
                >
                  Clear
                </Button>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "DesktopDatePicker",
                    "MobileDatePicker",
                  ]}
                >
                  <DatePicker
                    label="Ending Date"
                    maxDate={dayjs(todayDate)}
                    format="DD/MM/YYYY"
                    name="endingDate"
                    value={endingDate}
                    onChange={(value) => {
                      setEndingDate(value);
                      setEndingDateError(false);
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {endingDateError && (
                <FormHelperText color="error">
                  ending date is required
                </FormHelperText>
              )}
              {endingDate !== null && (
                <Button
                  sx={{ mt: 1, mb: -1 }}
                  onClick={() => setEndingDate(null)}
                  size="small"
                >
                  Clear
                </Button>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Starting Price"
                variant="outlined"
                inputProps={{ inputMode: "numeric" }}
                fullWidth
                name="startingPrice"
                value={staringPrice}
                onChange={(e) => {
                  const { value } = e.target;
                  if (!isNaN(value)) {
                    setStaringPrice(value);
                  }
                }}
                InputProps={{
                  endAdornment: staringPrice !== "" && (
                    <IconButton
                      size="small"
                      onClick={() => {
                        setStaringPrice("");
                        setEndingPriceError(false);
                      }}
                    >
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Ending Price"
                variant="outlined"
                inputProps={{ inputMode: "numeric" }}
                fullWidth
                name="endingPrice"
                value={endingPrice}
                onChange={(e) => {
                  const { value } = e.target;
                  if (!isNaN(value)) {
                    setEndingPrice(value);
                    setEndingPriceError(false);
                  }
                }}
                InputProps={{
                  endAdornment: endingPrice !== "" && (
                    <IconButton size="small" onClick={() => setEndingPrice("")}>
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
                error={endingPriceError}
                helperText={endingPriceError && "ending price is required"}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="delivery-status">Status</InputLabel>
                <Select
                  labelId="delivery-status"
                  value={deliveryStatus}
                  label="Status"
                  onChange={(e) => {
                    if (e.target.value === "clear") {
                      setDeliveryStatus("");
                    } else {
                      setDeliveryStatus(e.target.value);
                    }
                  }}
                >
                  <MenuItem
                    value="clear"
                    disabled={deliveryStatus === "" ? true : false}
                  >
                    Clear
                  </MenuItem>
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Preparing">Preparing</MenuItem>
                  <MenuItem value="In Transit">In Transit</MenuItem>
                  <MenuItem value="Out Of Delivery">Out Of Delivery</MenuItem>
                  <MenuItem value="Delivered">Delivered</MenuItem>
                  <MenuItem value="Return">Return</MenuItem>
                  <MenuItem value="Cancelled">Cancelled</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        {!max_width600 && (
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleApply}>Apply</Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
};

export default OrderFilter;
